import { Observable } from 'rxjs';

import { CvTemplateOutput } from 'document/model/cv-template.output';
import { DocumentOutput } from 'document/model/document.output';

import { SaveDocumentCmd } from '../command/save-document.cmd';
import { FetchDocumentsQuery } from '../query/fetch-documents.query';

export abstract class DocumentApiPort {
	public abstract fetchDocuments(
		query: FetchDocumentsQuery
	): Observable<DocumentOutput[]>;

	public abstract saveDocument(cmd: SaveDocumentCmd): Observable<DocumentOutput>;

	public abstract fetchCvTemplateDocuments(): Observable<CvTemplateOutput[]>;
}
